import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-6.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')